import { render, staticRenderFns } from "./ParcelasGrid.vue?vue&type=template&id=4ed9fbd8&scoped=true"
import script from "./ParcelasGrid.vue?vue&type=script&lang=js"
export * from "./ParcelasGrid.vue?vue&type=script&lang=js"
import style0 from "./ParcelasGrid.vue?vue&type=style&index=0&id=4ed9fbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9fbd8",
  null
  
)

export default component.exports